import React, { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SelectField from '../../components/Forms/Input/SelectField';
import AdminCashRegisterMonitorCard from '../../components/Cash/Monitor/AdminCashRegisterMonitorCard';
import AdminCashRegisterMonitorModal from '../../components/Cash/Monitor/AdminCashRegisterMonitorModal';
import { useBranch } from '../../hooks/branches/useBranch';
import { useAdminCashMonitor } from '../../hooks/cash/useAdminCashMonitor';
import { AdminCashRegisterMonitorDTO } from '../../types/cash/adminCashMonitor';

const CashAdminMonitorPage: React.FC = () => {
  const { fetchBranchDropdown, branchDropdown } = useBranch();
  const { registers, loading, fetchRegistersByBranch, clear } = useAdminCashMonitor();

  const [branchId, setBranchId] = useState<string | number>('');
  const [selectedRegister, setSelectedRegister] =
    useState<AdminCashRegisterMonitorDTO | null>(null);

  useEffect(() => {
    fetchBranchDropdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBranchChange = (value: string | number) => {
    setBranchId(value);

    if (value) {
      fetchRegistersByBranch(Number(value));
    } else {
      clear();
    }
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <div className="mb-5 rounded-sm border border-stroke bg-white p-5 shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="max-w-sm">
          <SelectField
            label="Sucursal"
            name="branchId"
            value={branchId}
            onChange={(e) => handleBranchChange(e.target.value)}
            options={[
              { value: '', label: 'Selecciona una sucursal' },
              ...branchDropdown.map((b: any) => ({ value: b.id, label: b.name })),
            ]}
            iconKey="branch"
          />
        </div>
      </div>

      {!branchId && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Selecciona una sucursal para ver el estado de sus cajas.
        </p>
      )}

      {branchId && loading && (
        <p className="text-sm text-gray-500 dark:text-gray-400">Cargando cajas...</p>
      )}

      {branchId && !loading && registers.length === 0 && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Esta sucursal no tiene terminales POS registradas.
        </p>
      )}

      {branchId && !loading && registers.length > 0 && (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
          {registers.map((register) => (
            <AdminCashRegisterMonitorCard
              key={register.registerId}
              register={register}
              onClick={setSelectedRegister}
            />
          ))}
        </div>
      )}

      <AdminCashRegisterMonitorModal
        register={selectedRegister}
        onClose={() => setSelectedRegister(null)}
      />
    </DefaultLayout>
  );
};

export default CashAdminMonitorPage;
